import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_CURRENCY } from '../../configs/app-global';

const initialState = {
  loading: false,
  currencies: [],
  defaultCurrency: DEFAULT_CURRENCY,
  error: '',
};

const currencySlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    setCurrencies(state, action) {
      const list = action.payload;
      state.currencies = Array.isArray(list) ? list : [];
    },
  },
});

export const { setCurrencies } = currencySlice.actions;
export default currencySlice.reducer;
